import React from 'react';

interface LoadingScreenProps {
  message?: string;
  isMobile?: boolean;
}

export default function LoadingScreen({ message = 'Waking up Nexus', isMobile = false }: LoadingScreenProps) {
  return (
    <div className="fixed inset-0 z-50 bg-black">
      {/* Desktop Animation */}
      {!isMobile && (
        <div className="hidden sm:block absolute inset-0 flex items-center justify-center">
          <div className="solar-system solar-system-centered">
            {/* Orbital rings */}
            <div className="orbit orbit-1"></div>
            <div className="orbit orbit-2"></div>
            <div className="orbit orbit-3"></div>
            <div className="orbit orbit-4"></div>
            
            {/* Positioned orbs */}
            <div className="orb orb-blue"></div>
            <div className="orb orb-purple"></div>
            <div className="orb orb-pink"></div>
            <div className="orb orb-blue-2"></div>
            <div className="orb orb-purple-2"></div>
            <div className="orb orb-pink-2"></div>
            <div className="orb orb-blue-3"></div>
            
            {/* Small particles */}
            <div className="particle particle-1"></div>
            <div className="particle particle-2"></div>
            <div className="particle particle-3"></div>
            <div className="particle particle-4"></div>
          </div>
        </div>
      )}

      {/* Mobile Animation */}
      {isMobile && (
        <div className="sm:hidden absolute inset-0 flex items-center justify-center">
          <div className="mobile-solar-system mobile-solar-system-centered">
            {/* Mobile orbital rings */}
            <div className="mobile-orbit mobile-orbit-1"></div>
            <div className="mobile-orbit mobile-orbit-2"></div>
            <div className="mobile-orbit mobile-orbit-3"></div>
            
            {/* Mobile orbs */}
            <div className="mobile-orb mobile-orb-1 mobile-orb-enhanced"></div>
            <div className="mobile-orb mobile-orb-2 mobile-orb-enhanced"></div>
            <div className="mobile-orb mobile-orb-3 mobile-orb-enhanced"></div>
            <div className="mobile-orb mobile-orb-4 mobile-orb-enhanced"></div>
            <div className="mobile-orb mobile-orb-5 mobile-orb-enhanced"></div>
          </div>
        </div>
      )}

      {/* Auto-detect responsive animation */}
      <div className="sm:hidden absolute inset-0 flex items-center justify-center">
        <div className="mobile-solar-system mobile-solar-system-centered">
          {/* Mobile orbital rings */}
          <div className="mobile-orbit mobile-orbit-1"></div>
          <div className="mobile-orbit mobile-orbit-2"></div>
          <div className="mobile-orbit mobile-orbit-3"></div>
          
          {/* Mobile orbs */}
          <div className="mobile-orb mobile-orb-1 mobile-orb-enhanced"></div>
          <div className="mobile-orb mobile-orb-2 mobile-orb-enhanced"></div>
          <div className="mobile-orb mobile-orb-3 mobile-orb-enhanced"></div>
          <div className="mobile-orb mobile-orb-4 mobile-orb-enhanced"></div>
          <div className="mobile-orb mobile-orb-5 mobile-orb-enhanced"></div>
        </div>
      </div>

      <div className="hidden sm:block absolute inset-0 flex items-center justify-center">
        <div className="solar-system solar-system-centered">
          {/* Orbital rings */}
          <div className="orbit orbit-1"></div>
          <div className="orbit orbit-2"></div>
          <div className="orbit orbit-3"></div>
          <div className="orbit orbit-4"></div>
          
          {/* Positioned orbs */}
          <div className="orb orb-blue"></div>
          <div className="orb orb-purple"></div>
          <div className="orb orb-pink"></div>
          <div className="orb orb-blue-2"></div>
          <div className="orb orb-purple-2"></div>
          <div className="orb orb-pink-2"></div>
          <div className="orb orb-blue-3"></div>
          
          {/* Small particles */}
          <div className="particle particle-1"></div>
          <div className="particle particle-2"></div>
          <div className="particle particle-3"></div>
          <div className="particle particle-4"></div>
        </div>
      </div>
      
      {/* Loading Text */}
      <div className="absolute inset-0 flex items-center justify-center z-10">
        <div className="text-center">
          <div className="sm:hidden mobile-loading-text">
            Waking up Nexus
            <span className="animated-dots">
              <span className="dot">.</span>
              <span className="dot">.</span>
              <span className="dot">.</span>
              <span className="dot">.</span>
              <span className="dot">.</span>
            </span>
          </div>
          <div className="hidden sm:block login-loading-text">
            Waking up Nexus
            <span className="animated-dots">
              <span className="dot">.</span>
              <span className="dot">.</span>
              <span className="dot">.</span>
              <span className="dot">.</span>
              <span className="dot">.</span>
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}
